import React from 'react'

export const Press = () => {
    return <div>Press</div>
}